export default __webpack_public_path__ + "static/media/spid-idp-posteid.7c2ce090.svg";